import { PropsWithChildren, ComponentType } from "react"
import { Typography } from "../typography"
import styled from "styled-components"

type DescriptionTextProps = {
  LeftIcon?: ComponentType
  RightIcon?: ComponentType
}

const DescriptionTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`

export const DescriptionText = ({ children, LeftIcon, RightIcon }: PropsWithChildren<DescriptionTextProps>) => {
  return (
    <DescriptionTextContainer>
      {LeftIcon && <LeftIcon />}
      <Typography $variant="caption-2" $color="grey.$500">
        {children}
      </Typography>
      {RightIcon && <RightIcon />}
    </DescriptionTextContainer>
  )
}
